export default __webpack_public_path__ + "static/media/top-glove.2f4c753d.png";